import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema, headingsUISchema } from '../Header';
import ExpandCollapseSections from './ExpandCollapseSections';

const schema: JSONSchema7 = {
    title: 'Expand Collapse Sections',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        titles: headingsSchema,
        sectionsList: {
            type: 'array',
            title: 'Sections',
            items: {
                type: 'object',
                properties: {
                    uniqueSectionId: {
                        type: 'string',
                        title: 'Unique Section Id',
                        default: '',
                    },
                    title: {
                        type: 'string',
                        title: 'Section Title',
                        default: '',
                    },
                    isPlaceHolder: {
                        type: 'boolean',
                        title: 'Is Place Holder',
                        default: false,
                    },
                },
                dependencies: {
                    isPlaceHolder: {
                        oneOf: [
                            {
                                properties: {
                                    isPlaceHolder: { enum: [false] },
                                    content: {
                                        type: 'string',
                                        description: 'Enter text here or html string',
                                        default: '',
                                        title: 'Content',
                                    },
                                },
                            },
                            {
                                properties: {
                                    isPlaceHolder: { enum: [true] },
                                },
                            },
                        ],
                    },
                },
            },
        },
        defaultActiveSection: {
            type: 'number',
            title: 'Default active section',
            default: 1,
            enum: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        },
        iconsType: {
            type: 'string',
            title: 'Icons type',
            enum: ['FontAwesome', 'Image'],
            default: 'FontAwesome',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default: 'return (data) => { return data }',
                        },
                    },
                },
            ],
        },
        iconsType: {
            oneOf: [
                {
                    properties: {
                        iconsType: { enum: ['FontAwesome'] },
                        expandIcon: {
                            type: 'string',
                            title: 'Enter value for Expand Icon',
                            default: 'fa-solid fa-plus',
                        },
                        collapseIcon: {
                            type: 'string',
                            title: 'Enter value for Collapse Icon',
                            default: 'fa-solid fa-minus',
                        },
                    },
                },
                {
                    properties: {
                        arrowIconType: { enum: ['Image'] },
                        expandIconImage: {
                            type: 'string',
                            title: 'Expand Icon Image',
                        },
                        collapseIconImage: {
                            type: 'string',
                            title: 'Collapse Icon Image',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'titles',
            'sectionsList',
            'defaultActiveSection',
            'iconsType',
            'expandIcon',
            'collapseIcon',
            'expandIconImage',
            'collapseIconImage',
        ],
        'Transform Data': ['isTransformData', 'functionToTransform'],
    },
];

const ExpandCollapseSectionsWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        isTransformData: { 'ui:widget': 'CustomCheckbox' },
        collapseIconImage: {
            'ui:placeholder': 'https://',
            'ui:widget': 'MediaPicker',
            'ui:options': {
                isImagePicker: true,
            },
        },
        expandIconImage: {
            'ui:placeholder': 'https://',
            'ui:widget': 'MediaPicker',
            'ui:options': {
                isImagePicker: true,
            },
        },
        expandIcon: { 'ui:widget': 'ResourcePicker' },
        collapseIcon: { 'ui:widget': 'ResourcePicker' },
        iconsType: { 'ui:widget': 'CustomSelect' },
        defaultActiveSection: { 'ui:widget': 'CustomSelect' },
        functionToTransform: { 'ui:widget': 'JSEditor' },
        titles: {
            ...headingsUISchema,
        },
        sectionsList: {
            items: {
                title: { 'ui:widget': 'ResourcePicker' },
                content: { 'ui:widget': 'ResourcePicker' },
                isPlaceHolder: { 'ui:widget': 'CustomCheckbox' },
                uniqueSectionId: { 'ui:widget': 'ResourcePicker' },
            },
        },
    },
    templateView: ExpandCollapseSections,
    id: 'ExpandCollapseSections',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ExpandCollapseSectionsWidget;
